import React, { useState } from 'react'
import DashboardHeader from '../Common/DashboardHeader'
import EmailInput from '../reusableComponents/EmailInput'
import FilterEmailInput from '../reusableComponents/FilterEmailInput'
import { useSelector } from 'react-redux'

const UploadFC = () => {
    const [userData, setUserData] = useState({
        email: '',
    })
    const [selectedOption, setSelectedOption] = useState('');

    const handleOptionChange = (option) => {
        setSelectedOption(option);
    };

    const v2pRMData = useSelector((state) => state.v2pRMData.V2PRMData);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setUserData(prevData => ({
            ...prevData,
            [name]: value
        }));
    }

    const displayedData = {
        result: {
            value: [
                {
                    srNo: 1,
                    v2prm: 'John Doe',
                    action: 'Edit',
                },
                // Add more data objects as needed
            ],
        },
    };

    return (
        <body className='mailsentbody'>
            <div >
                <div className="rightElement">
                    <DashboardHeader />
                    <div className="grid mt-6 grid-cols-12 gap-4">
                        <div className="col-span-12 md:col-span-2 lg:col-span-2"></div>
                        <div className="col-span-12 md:col-span-8 lg:col-span-8 ">
                            <div className="mt-2 p-2">
                                <div className="col-span-12">
                                    <h1 className="text-4xl text-center font-medium ">Upload File for Comparison</h1>
                                </div>
                            </div>
                            <div className='bg-white mx-2 shadow-xl p-6 mt-4 rounded-lg'>
                                <h1 className='mt-2 mb-2 text-xl'>Type</h1>
                                {/* Radio Buttons */}
                                <div className="flex ">
                                    <div>
                                        <input
                                            type="radio"
                                            id="radioOption1"
                                            name="radioOptions"
                                            className="form-radio h-5 w-5 text-indigo-600"
                                        />
                                        <label
                                            htmlFor="radioOption1"
                                            className="ml-2 text-gray-700"
                                        >
                                            Customer
                                        </label>
                                    </div>
                                    <div className='mx-4'>
                                        <input
                                            type="radio"
                                            id="radioOption2"
                                            name="radioOptions"
                                            className="form-radio h-5 w-5 text-indigo-600"
                                        />
                                        <label
                                            htmlFor="radioOption2"
                                            className="ml-2 text-gray-700"
                                        >
                                            Vendor
                                        </label>
                                    </div>
                                </div>
                                {/* End of Radio Buttons */}
                                {/* File Input */}
                                <div className="mt-6">
                                    <label className="text-gray-700 font-bold text-sm">Upload File (CSV, XLSX, XLS)</label>
                                    <br />
                                    <input type="file" className="mt-2" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" />
                                    <div className='mt-4'>
                                        <a href='https://elslogsuat.azurewebsites.net/template/sample-comparison-template.xlsx' target='_blank' className='text-red-400 font-normal hover:underline'>click here to download template</a>
                                    </div>
                                </div>
                                {/* End of File Input */}

                                <div className='mt-5 text-center'>
                                    <button className='vtpRm-action-button'>Upload</button>
                                </div>
                            </div>
                        </div>
                        <div className="col-span-12 md:col-span-2 lg:col-span-2"></div>
                    </div>
                </div>
            </div >
        </body >
    )
}

export default UploadFC
